var _linearGradient;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestBrowser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    width: 500.00003,
    height: 500.00003,
    viewBox: "0 0 132.29169 132.29169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#c19adb",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#366dc7",
      stopOpacity: 1
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#a",
    id: "b",
    x1: -39.60854,
    x2: 71.534149,
    y1: 2.4325852,
    y2: 30.395796,
    gradientTransform: "matrix(1.18628 0 0 1.10075 -5.126 -4.553)",
    gradientUnits: "userSpaceOnUse"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(52.653 52.652)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132.29167,
    height: 132.29167,
    x: -52.652737,
    y: -52.651997,
    ry: 39.687504,
    style: {
      display: "inline",
      fill: "url(#b)",
      stroke: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.314-19.697c-4.255 1.41-6.128 2.26-10.08 3.937-.873.371 1.235 1.388 2.006 1.967 1.19.863 2.368 1.76 3.71 2.318 1.311-.535 1.114-.986 2.476-2.926l.006-.007c.946-1.55 1.964-3.066 2.539-4.777a1.7 1.7 0 0 0-.27-.37.47.47 0 0 0-.387-.142m-38.277.455C-2.45-18.627-11.61-13.6-17.098-5.817c-2.806 4.498-2.25 10.813 1.368 14.705l.002.003c3.433 3.928 9.527 5.302 14.255 3.017l.002-.002C2.051 10.33 5.234 8.1 8.463 5.981 16.383.575 24.37-4.735 32.306-10.12c-6.805-6.756-15.92-9.566-25.269-9.123m29.774 8.437c-3.737 2.834-7.138 6.082-10.666 9.18v-.002C13.98 9.29-1.735 23.332-13.825 34.328c-.73.73-1.278 1.221-.017 2.482 4.906 5.4 13.717 9.232 20.67 9.788 7.296.447 14.854-1.191 20.926-5.36h.002c8.413-5.584 14.24-15.166 14.658-25.324.097-3.267-.021-6.57-.718-9.763-.652-3.073-2.1-5.897-3.089-8.89-.758-2.285-1.016-4.692-.995-7.083v-.004c.035-.828.027-1.612-.801-.979",
    style: {
      display: "inline",
      opacity: 1,
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestBrowser);
export default __webpack_public_path__ + "static/media/quest-browser.1c2cda4f7cd047a2a7a6019ed3efd3be.svg";
export { ForwardRef as ReactComponent };